//
// Hamilton Book specific scripts
// --------------------------------------------------

// Global variables to add to Perch's
// ---------------------------------------

var $logo_bookmark_wrapper 	= $('#global-logo-bookmark-wrapper'),
	$footer_sitemap_heading = $('.footer-sitemap-heading'),

	$search_reveal_button	= $('.search-expander-button'),
	$search_input 			= $('#master_search'),
	$search_menu 			= $("#logo-bookmark-contents");



// Context Closer
// ---------------------------------------
// What's this for...? 2017-10-26 KB
// ---------------------------------------
function contextClose(event) {
	var $group = $(this).closest('.context-closer-group');

	if($group.length) {
		var $el     = $group.find('.context-closer:checked');
		var checked = $el.length ? true : false;
		$el.toggleClass('is-closing-context', checked)
			.siblings($context_closer).toggleClass('is-closing-context', false);
	} else {
		var $el     = $(this);
		var checked = $el.prop('checked') ? true : false;
		$el.toggleClass('is-closing-context', checked);
	}

	var context_to_toggle;
	// use the data-attribute to identify the source to close/open
	if(context_to_toggle = $el.data("context-to-close-id")) {
		$("#" + context_to_toggle).toggleClass("is-context-closed", checked);
	} else if(context_to_toggle = $el.data("context-to-open-id")) {
		$("#" + context_to_toggle).toggleClass("is-context-closed", !checked);
	}
}

$context_closer = $(".context-closer");
$context_closer.on("change", contextClose).trigger('change');





// Search opening with a button/icon when at small desktop widths
// ---------------------------------------


// Search opening
// --------------------------
function openSearch () {
	// First, make the link highlighted & show the menu
	$search_reveal_button.addClass('is-active').attr('aria-expanded', 'true').attr('aria-pressed', 'true');
	$search_menu.addClass('is-open');
	$logo_bookmark_wrapper.addClass("search-is-manually-opened");
	// Then, select the input field
	$search_input.select();
}


// Search closing
// --------------------------
function closeSearch () {
	// Remove classes to the menu and the link
	// $(this).offsetWidth = $(this).offsetWidth;
	// $search_menu.addClass('animating-out');
	// setTimeout(function() {
		$search_reveal_button.removeClass('is-active').attr('aria-expanded', 'false').attr('aria-pressed', 'false');
		$search_menu.removeClass('is-open');
		// $search_menu.removeClass('animating-out');
		$logo_bookmark_wrapper.removeClass("search-is-manually-opened");
	// }, 250);
	return false;
};


// Logic
// --------------------------
// Close the menu if it's currently active. Otherwise: run openSearch function.
$search_reveal_button.click(function() {
	if ($(this).hasClass('is-active')) {
		closeSearch();
	}

	else {
		openSearch();
	}
});



// Collapsing Summary Tables
// ---------------------------------------
$summary_table 				= $(".summary-table");
$summary_table_wrapper 		= $(".summary-table-wrapper");

$summary_table.find("th").on("click", function() {
	$summary_table_wrapper.toggleClass("is-mobile-collapsed");
});



// Footer Sitemap open/close headings
// ---------------------------------------
$footer_sitemap_heading.on("click", function() {
	$(this).parent().toggleClass("is-mobile-collapsed");
});



// checkout submit
// ---------------------------------------
$(function(){
	// jQuery plugin to prevent double submission of forms
	$.fn.preventDoubleSubmission = function() {
	    return this.each(function() {
	        $(this).on('submit', function(e){
	            var $form = $(this);

	            if ($form.data('submitted') === true) {
	                // Previously submitted - don't submit again
	                e.preventDefault();
	                return false;
	            } else {
	                // Mark it so that the next submit can be ignored
	                $form.data('submitted', true)
	                	.find('[type="submit"], [type="image"]').prop('disabled', true);
	            }
	        });
	    });
	};

	$('#checkout-confirm-form, #checkout-confirm-form-top').preventDoubleSubmission();
});



// // Featured Products Slider
// // ---------------------------------------
// var $featured_products_slider = $('.featured-products-slider');

// $featured_products_slider.flickity({
// 	wrapAround: true,
// 	lazyLoad: true,
// 	autoPlay: 7000,
// 	imagesLoaded: true
// });



// Product Detail
// ---------------------------------------
jQuery(function($){

	// Sorry fancybox, kicking you to the curb.
	// If we need to re-implement this, maybe let's try it with the existing Bootstrap Modal plugin
	// $('.product-detail-photo-link').fancybox({
	// 	enableEscapeButton: true,
	// 	hideOnContentClick: true,
	// 	showCloseButton: true
	// });

	// Image thumbnails functionality — click on a non-active thumbnail to load a larger-size image in the larger size/regular/default image spot
	$('.thumb').on('mouseover click', function(e){
		e.preventDefault();

		var $me = $(this);
		if($me.hasClass('active')) return;

		$me.addClass('active').siblings('.active').removeClass('active');
		$('.product-detail-photo').attr('src', $me.attr('href'));
		$('.product-detail-photo-link').attr('href', $me.attr('data-full'));
	})
	// .on('click', function(e){  });
});


jQuery(function($){
	if (typeof $.fn.autotab_magic != 'undefined') {
		$('#code1').focus();
		$('#code1, #code2, #code3, #loader_icon_text').autotab_magic().autotab_filter('all');
	}
});

jQuery(function($){
	if (typeof $.fn.alphanumeric != 'undefined') {
		$('#customerAccount input.input-field').alphanumeric();
	}

	$('#customerAccount input.input-field').on('change', function() {
		if(isNaN($("#code1").val())) {
			$('#loader_icon').hide();
			$('#status').html('<span id="loader_icon_text" style="margin-left:10px; color:red; font-weight:bold;">The first field should be all numbers.</span>');
		}

		if($("#code1").val() !='' && $("#code2").val()!="" && $("#code3").val()!="") {
			checkCodes();
		}
	});

	function checkCodes(query_string) {
		var query_string = 'accnt_num='+$("#code1").val()+$("#code2").val()+'&cat_num='+$("#code3").val();

		$.ajax({
			beforeSend: function() {
				$('#loader_icon').hide();
				$('#loader_icon_text').hide();
				$('#status').html('<img id="loader_icon" style="margin-left:10px;" src="/images/misc/ajax-loader.gif" />');
			},
			complete: function(){
				$('#loader_icon').hide();
			},
			type: "POST",
			url: "/customerxml/get",
			'data' : query_string,
			dataType: 'xml',
			success: function(xml) {
				if($('#actions').length == 0) {
					$('#status').after('<div class="field" id="actions"><a href="/catalog/edit_info" class="button">No</a> <a href="/quick_order" class="button">Yes</a></div>');
				}

				$(xml).find('customer').each(function(){
					if($(this).find('last_name').text()!="") {
						$('#status').html('Is this you? '+ $(this).find('first_name').text() +' '+$(this).find('last_name').text() + "<br />");
						$('#status').css('font-weight','bold');
						$('#status').css('font-size','15px');
					} else if ($(this).find('bpcode').text()=="true") {
						$('#status').html("The number is valid. Do you wish to continue?<br />");
						$('#status').css('font-weight','bold');
						$('#status').css('font-size','15px');
					} else {
						// $('#status').html($(this).find('bill_to_company_name').text());
						$('#status').html($(this).find('company').text());
					}
				});
			},
			error: function() {
				if(isNaN($("#code1").val())) {
					$('#status').html('<span id="loader_icon_text" style="margin-left:10px; color:red; font-weight:bold;">The first field should be all numbers.</span>');
				} else {
					$('#status').html('<span id="loader_icon_text" style="margin-left:10px; color:red; font-weight:bold;">No account information found. Double check your code.</span>');
				}

			}

		});

		return true;
	}
});

jQuery(function($){
	//setup some fields to be required or removed as needed
	var arr = [ "ship_to_first_name", "ship_to_last_name", "ship_to_address", "ship_to_city", "ship_to_state", "ship_to_postal_code" ];

	// Set some defaults
	$('.account-details .delivery-address input').each(function () {
		if(jQuery.inArray( this.name , arr ) !== -1) {
			$(this).attr('required', true); // Set html5 required attribute
			$(this).attr('aria-required', true); // Set aria-required attribute
			$(this).addClass('required');
		}
	});

	$('.account-details #ship_to_state').attr('required', true); // Set html5 required attribute on the delievery state select box
	$('.account-details #ship_to_state').attr('aria-required', true); // Set aria-required attribute on the delievery state select box
	$('.account-details #ship_to_state').addClass('required');

	// when user clicks (toggles) "Same as billing address" ...
	$(".account-details #same_as_bill_to").on('change', function() {// ... if not checked...
		var check = $('.account-details #same_as_bill_to').is(':checked');

		$(".account-details #customer_details_shipping .flaz").toggle( !check );

		// ... then let's use html5 to require the delivery address fields.
		$('.account-details .delivery-address input').each(function () {
			if(jQuery.inArray( this.name , arr ) !== -1) {
				if(check) {
					$(this).attr('required', false);
					$(this).attr('aria-required', false);
					$(this).removeClass('required');
				} else {
					$(this).attr('required', true);
					$(this).attr('aria-required', true);
					$(this).addClass('required');
				}
			}
		});

		if(check) {
			$('.account-details #ship_to_state').attr('required', false);
			$('.account-details #ship_to_state').attr('aria-required', false);
			$('.account-details #ship_to_state').removeClass('required');
		} else {
			$('.account-details #ship_to_state').attr('required', true);
			$('.account-details #ship_to_state').attr('aria-required', true);
			$('.account-details #ship_to_state').addClass('required');
		}
	}).trigger('change');
});

jQuery(document).ready(function($) {
	confirm_login();
});

function confirm_login() {
	setTimeout(function(){$('.logged-in-container').hide()},5000);
}

// Bootstrap Dismissable Alert
// --------------------------------------------------
// Note: .alert CSS was built from the
// 		 ground up by @k_bav as an exercise.
//		 This JS is Bootstrap's for .alert dismissal.
// --------------------------------------------------
// $(document).ready(function(){
// 	$(".alert").alert();
// });


jQuery(document).ready(function($) {
    var str = "";
    //change name of binding select
    $("#binding").change(function () {
        $(this).attr('name', 'pf['+$(this).val()+']');
    });
});

jQuery(document).ready(function($) {
	reloadCart();
	$('#global-main').on('click', '.product-add-to-cart-button', function(e) {
		e.preventDefault();
		var button = $(this);
		var postData = button.parent('.add-to-cart-form').serialize();
		button.addClass('is-ajax-hiding');
		checkCart(postData, button);
	});
	$('#global-main').on('click', '.cart-add-again--yes', function(e) {
		e.preventDefault();
		var form = $(this).closest('.add-to-cart-form');
		var postData = form.serialize();
		var button = $('.product-add-to-cart-button', form);
		button.addClass('is-ajax-hiding');
		addToCart(postData, button);
	});
	$('#global-main').on('click', '.cart-add-again--no', function(e) {
		e.preventDefault();
		var form = $(this).closest('.add-to-cart-form');
		var button = $('.product-add-to-cart-button', form);
		button.removeClass('is-ajax-hiding');
		$(this).closest('.cart-ajax-message').addClass('is-ajax-hiding').removeClass('error');
	});
});

function checkCart(postData, button) {
	$.ajax({
		type: "POST",
		url: "/check_cart",
		'data' : postData,
		dataType: 'text',
		success: function(text) {
			if(parseInt(text) == 1) { //if we have 1 item that exists in the cart already
				button.siblings('.cart-ajax-message').html('<i class="icon-alert" aria-hidden="true"></i><br>Item is in your cart already. Add it again? <a href="#" class="cart-add-again--yes">Yes</a> <a href="#" class="cart-add-again--no">No</a>').removeClass('is-ajax-hiding').addClass('error');
			} else {
				addToCart(postData, button);
			}
		}
	});
}

function addToCart(postData, button) {
	$.ajax({
		beforeSend: function() {
			button.addClass('is-ajax-hiding');
		},
		type: "POST",
		url: "/cart/add",
		data : postData,
		dataType: 'json',
		success: function(data) {
			if (data.error == true) {
				var message = 'Item could not be added to&nbsp;cart. Please try again&nbsp;later.';
				if(data.error_message !== undefined && data.error_message !== '') {
					message = data.error_message;
				}
				button.siblings('.cart-ajax-message').html('<i class="icon-alert" aria-hidden="true"></i><br>' + message).removeClass('is-ajax-hiding').addClass('error');
			} else {
				button.siblings('.cart-ajax-message').html('<i class="icon-checkmark" aria-hidden="true"></i><br>Item&nbsp;added to&nbsp;cart!').removeClass('is-ajax-hiding error');
			}
			reloadCart();

		},
		error: function(data) {
			button.siblings('.cart-ajax-message').html('Item could not be added to cart. Please try again later.').removeClass('is-ajax-hiding').addClass('error');
		}

	});
	setTimeout(function() {
		button.siblings('.cart-ajax-message').addClass('is-ajax-hiding').removeClass('error');
		button.removeClass('is-ajax-hiding');
	}, 6000);
}

function reloadCart() {
	$.ajax({
		type: "POST",
		url: "/cart/ajax_cart",
		dataType: 'json',
		success: function(data) {
			$('.ajax-cart-item-count').html(data.item_count);
			$('.ajax-cart-subtotal').html(data.subtotal);
		}
	});
}

$(window).on("popstate", function(event) {
	var postData;

	if(location.search === '') {
		return;
	}
	// if (event.originalEvent.state !== null) {
		postData = location.search.replace("?", "");
	// }

	refreshSearch(postData, $('.search-filter-form'));
});

jQuery(document).ready(function($) {

	$('#global-main')
		.on('click', '.button--refine-search', function(e) {
			e.preventDefault();
			var $form = $(this).closest('.search-filter-form');
			var postData = $form.serialize();

			refreshSearch(postData, $form);
		})
		.on('change', '.throttle_selector > form > select', function(e) {
			var $form = $(this).closest('form');
			var postData = $form.serialize();

			refreshSearch(postData, $form);
		});

	// Ajax search when facet changed removed by BM on 6/21/18 per HB
	// $('#global-main').on('change', '.search-filter-form input', function(e) {
	// 	e.preventDefault();
	// 	var form = $(this).closest('.search-filter-form');
	// 	var postData = form.serialize();
	// 	refreshSearch(postData, form);
	// });
	// $('#global-main').on('change', '.global-filter-dropdown-categories', function(e) {
	// 	e.preventDefault();
	// 	var form = $(this).closest('.search-filter-form');
	// 	var postData = form.serialize();
	// 	refreshSearch(postData, form);
	// });
	// $('#global-main').on('change', '.throttle_selector form select', function(e) {
	// 	e.preventDefault();
	// 	var form = $(this).closest('.throttle_selector form');
	// 	var postData = form.serialize();
	// 	refreshSearch(postData, form);
	// });
});

function refreshSearch(postData, form) {
	$.ajax({
		type: "GET",
		url: window.location.pathname,
		data : postData,
		dataType: 'html',
		success: function(data) {
			if (data.error == true) {
				form.submit();
			} else {
				$('.search-page-outer-wrapper').replaceWith(data);

				if(postData) {
					history.pushState(postData, document.title, window.location.pathname + "?" + postData);
				}

				window.scrollTo(0,0);
			}
			// reloadCart();
		},
		error: function(data) {
			form.submit();
		},
	});
}


jQuery(document).ready(function($) {
	// If browser has media query support for hover (read: primary input method) detection, and hover is indeed not the primary input method...
	if(matchMedia('(hover: none)').matches) {
		$('html').addClass('hover-not-primary-input-method');
	}
});

//Email Preferences
jQuery(function($){

	$('.select-all-email-preferences').on('click', function() {
		$('#type-subject-area-of-interest').prop('checked', true).trigger("change");
		$('.child-checkbox:checkbox').prop('checked', true);
	});

	$('.clear-all-email-preferences').on('click', function() {
		$('#type-subject-area-of-interest').prop('checked', false).trigger("change");
		$('.child-checkbox:checkbox').prop('checked', false);
	});

	$('#type-subject-area-of-interest').on('change', function() {
		$parent = $(this).parents('.email-type-wrapper');
		$checkboxes = $parent.find('.child-checkbox:checkbox');
		$childCheckboxHeader = $('#child-checkbox-header');

		if(!$(this).prop('checked')) {
			$checkboxes.addClass('disabled')
				.prop('checked', false)
				.prop('disabled', true);

			$childCheckboxHeader.addClass('disabled');

			$checkboxes.siblings().addClass('disabled');
		} else {
			$checkboxes.removeClass('disabled').prop('disabled', false);

			$checkboxes.siblings().removeClass('disabled');

			$childCheckboxHeader.removeClass('disabled');
		}
	});

	$('#unsubscribe-from-all-button').on('click', function() {
		$('#unsubscribe-from-all-form').submit();
	});

  $('#unsubscribe-from-cart-button').on('click', function() {
		$('#unsubscribe-from-cart-form').submit();
	});

});

function showTooltip(evt, text) {
  var tooltip = document.getElementById("tooltip");
  tooltip.innerHTML = text;
  tooltip.style.display = "block";
  tooltip.style.left = evt.clientX + 10 + 'px';
  tooltip.style.top = evt.clientY + 10 + 'px';
}

function hideTooltip() {
  var tooltip = document.getElementById("tooltip");
  tooltip.style.display = "none";
}

// anchor links
jQuery(document).ready(function($) {

  if(!$('#checkout-steps').length) {
    $('[href^="#"]').not('[href="#"]').not('[data-toggle]').on('click', function(e) {
      var $to = $(this.getAttribute('href'));

      if($to) {
        $([document.documentElement, document.body]).animate({
          scrollTop: $to.offset().top
        }, 500);
      }
    });
  }

});
